export { default } from './Illustration'
